import { lazy } from 'react'
import { Route } from 'react-router-dom'

const ShopHomePage = lazy(() => import('@/pages/public/ShopHomePage'))
const ShopCartPage = lazy(() => import('@/pages/public/ShopCartPage'))
const ShopBlogPostPage = lazy(() => import('@/pages/public/ShopBlogPostPage'))
const ShopCheckoutPage = lazy(() => import('@/pages/public/ShopCheckoutPage'))
const ShopCheckoutConfirmationPage = lazy(
  () => import('@/pages/public/ShopCheckoutConfirmationPage'),
)
const ShopCheckoutReturnPage = lazy(() => import('@/pages/public/ShopCheckoutReturnPage'))
const ShopDemoPayPage = lazy(() => import('@/pages/public/ShopDemoPayPage'))
const ShopAirwallexPayPage = lazy(() => import('@/pages/public/ShopAirwallexPayPage'))
const ShopProductDetailPage = lazy(() => import('@/pages/public/ShopProductDetailPage'))
const ShopEventTicketsPage = lazy(() => import('@/pages/public/ShopEventTicketsPage'))
const ShopEventDetailPage = lazy(() => import('@/pages/public/ShopEventDetailPage'))
const ShopDynamicCmsPage = lazy(() => import('@/pages/public/ShopDynamicCmsPage'))

/** Shared child routes for /shop/:slug and custom-domain storefront roots. */
export function ShopStorefrontChildRoutes() {
  return (
    <>
      <Route index element={<ShopHomePage />} />
      <Route path="cart" element={<ShopCartPage />} />
      <Route path="checkout" element={<ShopCheckoutPage />} />
      <Route path="checkout/confirmation" element={<ShopCheckoutConfirmationPage />} />
      <Route path="checkout/return" element={<ShopCheckoutReturnPage />} />
      <Route path="demo-pay" element={<ShopDemoPayPage />} />
      <Route path="airwallex-pay" element={<ShopAirwallexPayPage />} />
      <Route path="blog/:postSlug" element={<ShopBlogPostPage />} />
      <Route path="products/:productRef" element={<ShopProductDetailPage />} />
      <Route path="events/:publicId/tickets" element={<ShopEventTicketsPage />} />
      <Route path="events/:publicId" element={<ShopEventDetailPage />} />
      <Route path=":pageSlug" element={<ShopDynamicCmsPage />} />
    </>
  )
}
